import React from "react";
import "./FeaturesGrid.css";





const FeaturesGrid = ({features, hasHeading}) => {
  return (
    
    <div className="container my-5 ">
      {hasHeading && (
  <>
    <h2 className="fw-bold my-2">Web Design Services</h2>
    <div className="mx-auto mb-3" style={{
      width: '60px',
      height: '4px',
      backgroundColor: '#3bc9f5',
      borderRadius: '2px'
    }}></div>
    <p className="mb-5 fw-bold text-secondary" >Your Website function as an extension of your company. Allow our web design specialists to assist you in creating a website that is simple to navigate, discover the information they require, and begin the process of becoming a lead.</p>
  </>
)}

      <div className="row g-4 ">
        {features.map((feature) => (
          <div key={feature.id} className="col-md-3 ">
            <div className="card feature-card text-start p-3">
              <div className="position-relative d-inline-block mb-3">
                <div className="number-circle">{feature.id}</div>
                <div className="icon-circle ">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="img-fluid "
                    width="50"
                  />
                </div>
              </div>
              <h5 className="fw-bold">{feature.title}</h5>
              <p className="text-muted small">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesGrid;
